import { Component, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { AuthService } from "@core/auth.service";
import { TranslateService } from "@ngx-translate/core";
import { Subject, takeUntil } from "rxjs";
import { IonicModule } from "@ionic/angular";

@Component({
    selector: "app-redirect-uri",
    templateUrl: "./redirect-uri.component.html",
    styleUrls: ["./redirect-uri.component.scss"],
    standalone: true,
    imports: [IonicModule],
})
export class RedirectUriComponent implements OnInit {
  translatedToastMsg: any;
  selectedLanguage: string = "en";
  private destroy$ = new Subject<void>();
  constructor(private actRoute: ActivatedRoute, private router: Router, public translate: TranslateService, private authService: AuthService) {
    this.authService.selectedlanguage$.pipe(takeUntil(this.destroy$)).subscribe(
      (l) => {
        this.selectedLanguage = l;
        translate.use(l ? l : "en");
      },
      (err) => {
        return err;
      }
    );

    this.authService.getConstantsMsg$.pipe(takeUntil(this.destroy$)).subscribe((msg: any) => {
      this.translatedToastMsg = msg?.static_messages_pwa;
    })
    this.actRoute.queryParams.pipe(takeUntil(this.destroy$)).subscribe((d) => {
      if (!d) return;
      if (Object.keys(d)?.length > 0) {
        if (typeof localStorage === 'object') {
          try {
            const currentRoute = localStorage.getItem('currentRoute');
            localStorage.setItem('isPaymentDone', 'true');
            localStorage.setItem("d", JSON.stringify(d));
            const transferParam = window.origin || location.origin || "https://app.lottosocial.com";
            // To delay the post message logic to allow the redirection logic to complete & load the correct payment page
            setTimeout(() => {
              window.parent.window.postMessage({ for: "paymentDone", data: JSON.stringify(d) }, transferParam);
            }, 2000);
            this.router.navigateByUrl(currentRoute);
          } catch (e) {
            Storage.prototype._setItem = Storage.prototype.setItem;
            Storage.prototype.setItem = function () { };
            /* const msg = this.translatedToastMsg?.["1083"]?.[this.selectedLanguage];
            this.authService.showToast(msg ? msg : "Your web browser does not support storing settings locally. In Safari, the most common cause of this is using 'Private Browsing Mode'. Some settings may not save or some features may not work properly for you.", "warning", ""); */
            this.authService.getConstantsMsg("1083").then((translatedMsg) => {
              const defaultMsg = {
                message: {
                  line_1: "Your web browser does not support storing settings locally. In Safari, the most common cause of this is using 'Private Browsing Mode'. Some settings may not save or some features may not work properly for you.",
                  line_2: "",
                },
                style: {
                  icon: "tick circle alert.svg",
                  type: "warning",
                },
              }
              this.authService.showToastMessage(translatedMsg, defaultMsg);
            }).catch((err) => {
              return err;
            });
          }
        }

      }
    }, (err) => { 
      return (err)
    });
  }

  ngOnInit() {}

  ionViewWillLeave() {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
